/**
 * Created by calcium.wong on 2/12/2016.
 */

define('ctrl/home/home-v2',['require','ns','ctrl/base'],function (require) {
    'use strict';

    var ns = require('ns');

    var BaseController = require('ctrl/base');

    var _selector = {
        latestVideoItem: ".latest-video-item",
        langSelector: '#footer-lang-selector'
    };

    var $selector = {};

    var HomeV2Controller = BaseController.extend({

        _calLatestVideoHeight: function() {

            var height = 0;

            _.each ($selector.latestVideoItem , function (val, i) {

               height = ($(val).height() > height)? $(val).height() : height;

            });

            $selector.latestVideoItem.height(height);

        },

        _changeLang: function () {

            var value = $selector.langSelector.val();


            if (!_.isUndefined(value)) {

                window.location.href = value;

            }

        },

        _registerEvent: function () {

            var that = this;

            $selector.latestVideoItem.click(function() {

                window.location.href = 'http://hyperurl.co/opensky.tv';

            });

            $selector.langSelector.change(function(){

                if ($selector.langSelector.is(":visible")) {

                    that._changeLang();

                }

            });

            $(window).resize(function() {

                $selector.latestVideoItem.removeAttr('style');

                that._calLatestVideoHeight();

            });

        },

        init: function () {

            BaseController.prototype.init.call(this);

            $selector = ns.utils.generateSelector(_selector);

            this._registerEvent();

            this._calLatestVideoHeight();

        }

    });

    return HomeV2Controller;
});
